import { render } from "./AddCandidate.vue?vue&type=template&id=02e17650&scoped=true"
import script from "./AddCandidate.vue?vue&type=script&lang=js"
export * from "./AddCandidate.vue?vue&type=script&lang=js"

import "./AddCandidate.vue?vue&type=style&index=0&id=02e17650&scoped=true&lang=css"

import exportComponent from "/builds/coditas-projects/dialog360-whatsapp/frontend/whatsapp-exotel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e17650"]])

export default __exports__